/*
  Hero split -- floating review slider (Swiper, vertical).
  Loads Swiper from CDN only if the theme has not already defined it, then boots a
  vertical slider with vertical dots and optional autoplay. Per-section, editor-safe,
  respects reduced motion.

  COREEX Focal port: carried over from dev-coreex-theme unchanged. This file has no
  Dawn dependency -- it keys off the .hero-split class names and the data-*
  attributes on the section root, all of which the Focal markup keeps. Focal bundles
  Flickity, not Swiper, so window.Swiper is always absent and the CDN loader runs;
  the two libraries share no globals or class names.
*/
(function () {
  'use strict';

  var CDN_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var CDN_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function ensureSwiper(cb) {
    if (window.Swiper) return cb();

    if (!document.getElementById('swiper-cdn-css')) {
      var link = document.createElement('link');
      link.id = 'swiper-cdn-css';
      link.rel = 'stylesheet';
      link.href = CDN_CSS;
      document.head.appendChild(link);
    }

    var existing = document.getElementById('swiper-cdn-js');
    if (existing) {
      existing.addEventListener('load', cb);
      return;
    }

    var s = document.createElement('script');
    s.id = 'swiper-cdn-js';
    s.src = CDN_JS;
    s.addEventListener('load', cb);
    document.head.appendChild(s);
  }

  function initSection(section) {
    if (!section || section.__heroSplitInit) return;

    var slider = section.querySelector('.hero-split__reviews-slider');
    if (!slider) return;

    var slideCount = slider.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    section.__heroSplitInit = true; // claim it so re-entry bails

    var dots = section.querySelector('.hero-split__reviews-dots');
    var autoplayOn = section.getAttribute('data-autoplay') === 'true';
    var delay = (parseFloat(section.getAttribute('data-autoplay-speed')) || 4) * 1000;

    ensureSwiper(function () {
      section.__heroSwiper = new Swiper(slider, {
        direction: 'vertical',
        loop: slideCount > 1,
        slidesPerView: 1,
        speed: 500,
        autoplay:
          autoplayOn && slideCount > 1 && !reduced.matches
            ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false,
        pagination: dots ? { el: dots, clickable: true } : false,
        a11y: { enabled: true },
      });
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.hero-split');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.hero-split');
    if (section && section.__heroSwiper) {
      section.__heroSwiper.destroy(true, true);
      section.__heroSwiper = null;
      section.__heroSplitInit = false;
    }
  });
})();
